import React, { useContext } from "react";

import ConfirmDeleteButton from "../../Common/ConfirmDeleteButton";
import UIToggle from "../../Common/UIToggle";
import { ACCOUNT_DELETE_CONFIRM_TITLE } from "../../../constants/accountDeletion";
import { StudentInfoContext } from "./StudentInfoContext";
import StudentPolygonField from "./StudentPolygonField";

export default function StudentOverviewTab() {
   const {
      studentId,
      isStaffViewer,
      studentPolygonDistrict,
      onPolygonSaved,
      canEditStudentProfile,
      formData,
      handleChange,
      canShowSensitiveProfileFields,
      groupsStatus,
      availableGroupsForSelect,
      absText,
      extrasSaving,
      extrasReady,
      onAbsFocus,
      onAbsChange,
      onAbsBlur,
      onAbsKeyDown,
      desiredInstructorId,
      desiredInstructorName,
      extrasForm,
      toggleField,
      groupsError,
      extrasError,
      saveError,
      saving,
      canDeleteStudent,
      deleteError,
      deleting,
      handleDelete,
      handleSave,
      resetProfileForm,
      profileRows,
   } = useContext(StudentInfoContext);

   return (
      <>
         {canEditStudentProfile ? (
            <div className="studentsProfileUI__form">
               <div className="studentsProfileUI__editCard">
                  <div className="studentsProfileUI__fieldGrid">
                     <label className="studentsProfileUI__field">
                        <span className="studentsProfileUI__fieldLabel">
                           Prenume
                        </span>
                        <input
                           type="text"
                           name="firstName"
                           value={formData.firstName}
                           onChange={handleChange}
                           placeholder="Prenume"
                           className="studentsProfileUI__input"
                        />
                     </label>

                     <label className="studentsProfileUI__field">
                        <span className="studentsProfileUI__fieldLabel">
                           Nume
                        </span>
                        <input
                           type="text"
                           name="lastName"
                           value={formData.lastName}
                           onChange={handleChange}
                           placeholder="Nume"
                           className="studentsProfileUI__input"
                        />
                     </label>

                     <label className="studentsProfileUI__field">
                        <span className="studentsProfileUI__fieldLabel">
                           Telefon
                        </span>
                        <input
                           type="text"
                           name="phone"
                           value={formData.phone}
                           onChange={handleChange}
                           placeholder="Telefon"
                           className="studentsProfileUI__input"
                        />
                     </label>

                     {canShowSensitiveProfileFields && (
                        <label className="studentsProfileUI__field">
                           <span className="studentsProfileUI__fieldLabel">
                              Grupă
                           </span>
                           <select
                              name="groupId"
                              value={formData.groupId}
                              onChange={handleChange}
                              className="studentsProfileUI__select"
                              disabled={groupsStatus === "loading"}
                           >
                              <option value="">
                                 {groupsStatus === "loading"
                                    ? "Se încarcă grupele..."
                                    : availableGroupsForSelect.length > 0
                                      ? "Mută în altă grupă"
                                      : "Nu există grupe disponibile"}
                              </option>

                              {availableGroupsForSelect.map((group) => (
                                 <option key={group.id} value={group.id}>
                                    {group?.name || "Grupă"}
                                 </option>
                              ))}
                           </select>
                        </label>
                     )}

                     {canShowSensitiveProfileFields && (
                        <label className="studentsProfileUI__field">
                           <span className="studentsProfileUI__fieldLabel">
                              IDNP
                           </span>
                           <input
                              type="text"
                              name="idnp"
                              value={formData.idnp}
                              onChange={handleChange}
                              placeholder="IDNP"
                              className="studentsProfileUI__input"
                           />
                        </label>
                     )}

                     {canShowSensitiveProfileFields && (
                        <label className="studentsProfileUI__field">
                           <span className="studentsProfileUI__fieldLabel">
                              Absențe
                           </span>
                           <input
                              type="text"
                              name="number_of_absences"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              value={absText}
                              disabled={extrasSaving || !extrasReady}
                              onFocus={onAbsFocus}
                              onChange={onAbsChange}
                              onBlur={onAbsBlur}
                              onKeyDown={onAbsKeyDown}
                              className="studentsProfileUI__input"
                           />
                        </label>
                     )}

                     {desiredInstructorId && (
                        <label className="studentsProfileUI__field">
                           <span className="studentsProfileUI__fieldLabel">
                              Instructor preferat
                           </span>
                           <input
                              type="text"
                              value={desiredInstructorName || "—"}
                              readOnly
                              className="studentsProfileUI__input"
                           />
                        </label>
                     )}

                     <label className="studentsProfileUI__field studentsProfileUI__field--full">
                        <span className="studentsProfileUI__fieldLabel">
                           Email
                        </span>
                        <input
                           type="email"
                           name="email"
                           value={formData.email}
                           onChange={handleChange}
                           placeholder="Email"
                           className="studentsProfileUI__input"
                        />
                     </label>

                     {canShowSensitiveProfileFields && (
                        <label className="studentsProfileUI__field studentsProfileUI__field--toggle studentsProfileUI__field--full">
                           <span className="studentsProfileUI__fieldLabel">
                              Doc. medicale
                           </span>
                           <UIToggle
                              checked={extrasForm.medical_documents === true}
                              onChange={() => toggleField("medical_documents")}
                              disabled={extrasSaving || !extrasReady}
                              aria-label="Doc. medicale"
                           />
                        </label>
                     )}

                     {canShowSensitiveProfileFields && (
                        <label className="studentsProfileUI__field studentsProfileUI__field--toggle studentsProfileUI__field--full">
                           <span className="studentsProfileUI__fieldLabel">
                              Lucru individual
                           </span>
                           <UIToggle
                              checked={extrasForm.individual_work === true}
                              onChange={() => toggleField("individual_work")}
                              disabled={extrasSaving || !extrasReady}
                              aria-label="Lucru individual"
                           />
                        </label>
                     )}

                     {canShowSensitiveProfileFields && (
                        <label className="studentsProfileUI__field studentsProfileUI__field--toggle studentsProfileUI__field--full">
                           <span className="studentsProfileUI__fieldLabel">
                              Permite Ex. practic
                           </span>
                           <UIToggle
                              checked={extrasForm.canBookPracticalExam === true}
                              onChange={() => toggleField("canBookPracticalExam")}
                              disabled={extrasSaving || !extrasReady}
                              aria-label="Permite Ex. practic"
                           />
                        </label>
                     )}

                     {isStaffViewer && (
                        <StudentPolygonField
                           studentId={studentId}
                           value={studentPolygonDistrict}
                           onSaved={onPolygonSaved}
                        />
                     )}
                  </div>
               </div>

               {groupsStatus === "failed" && groupsError && (
                  <div className="studentsProfileUI__stateCard studentsProfileUI__stateCard--error">
                     {groupsError}
                  </div>
               )}
               {extrasError && (
                  <div className="studentsProfileUI__stateCard studentsProfileUI__stateCard--error">
                     {extrasError}
                  </div>
               )}
               {saveError && (
                  <div className="studentsProfileUI__stateCard studentsProfileUI__stateCard--error">
                     {saveError}
                  </div>
               )}
               {deleteError && (
                  <div className="studentsProfileUI__stateCard studentsProfileUI__stateCard--error">
                     {deleteError}
                  </div>
               )}

               <div className="studentsProfileUI__btns">
                  {canDeleteStudent && (
                     <ConfirmDeleteButton
                        disabled={saving || deleting}
                        onConfirm={handleDelete}
                        fullWidth={false}
                        label={deleting ? "Se șterge..." : "Șterge"}
                        confirmLabel={deleting ? "Se șterge..." : "Da, șterge"}
                        cancelLabel="Nu"
                        confirmTitle={ACCOUNT_DELETE_CONFIRM_TITLE}
                     />
                  )}

                  <button
                     className="studentsProfileUI__btn studentsProfileUI__btn--save"
                     onClick={handleSave}
                     disabled={saving}
                  >
                     {saving ? "Salvez..." : "Salvează"}
                  </button>

                  <button
                     className="studentsProfileUI__btn studentsProfileUI__btn--normal"
                     onClick={resetProfileForm}
                     disabled={saving}
                  >
                     Resetează
                  </button>
               </div>
            </div>
         ) : (
            <>
               <div className="students-info__detailRows">
                  {profileRows.map((row) => (
                     <div key={row.key} className="students-info__detailRow">
                        <span>{row.label}</span>
                        <strong>{row.value}</strong>
                     </div>
                  ))}
               </div>

               {groupsStatus === "failed" && groupsError && (
                  <p className="students-info__error">{groupsError}</p>
               )}
            </>
         )}
      </>
   );
}
